module.exports = __webpack_public_path__ + "img/collection-weddingRings@2x.a8c47a3.jpg";